<template>
  <div>
    <FuncionalidadeHeader
      v-if="funcData.parametros.textos.esqueciSenhaTituloNavegacao"
      :titulo="funcData.parametros.textos.esqueciSenhaTituloNavegacao"
      :custom-voltar="true"
      :info="false"
      :login="true"
      @click="$emit('voltar')"/>
    <p
      v-if="funcData.parametros.textos.esqueciSenhaCabecalho"
      class="recuperar-cabecalho"
    >
      {{ funcData.parametros.textos.esqueciSenhaCabecalho }}
    </p>

    <div
      id="form-render-identificacao"
    />

    <p
      v-if="funcData.parametros.textos.esqueciSenhaRodape"
      class="recuperar-rodapé"
    >
      {{ funcData.parametros.textos.esqueciSenhaRodape }}
    </p>
    <AlertaErro
      v-model="erro.show"
      :title="erro.titulo"
      :description="erro.descricao"
    />
    <ButtonDefault
      :title="funcData.parametros.textos.esqueciSenhaBotaoEnviar"
      @click="enviar"
    />
    <ButtonDefault
      v-if="config.configuracaoAcesso.centralDeAjuda.ativo"
      :title="'Central de ajuda'"
      :secundario="true"
    />
    <DialogDefault
      :open.sync="mostrarErro.show"
      title="Atenção"
      width="370px"
      @close="mostrarErro.show = false"
      :close-on-click-modal="false"
    >
      <div>
        <div
          style="text-align: center; font: normal normal normal 14px/19px Open Sans; letter-spacing: 0; color: #000000; opacity: 0.8;">
          {{mostrarErro.descricao}}
        </div>
        <ButtonDefault title="ENTENDI" @click="$emit('voltar')" />
      </div>
    </DialogDefault>
  </div>
</template>

<script>
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { mapActions, mapGetters, mapState } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

export default {
  name: 'RecuperarSenhaIdentificacao',
  components: {
    FuncionalidadeHeader,
    AlertaErro,
    ButtonDefault,
    DialogDefault
  },
  data () {
    return {
      form: {},
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: ''
      },
      mostrarErro: {
        show: false,
        descricao: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    funcData () {
      return this.config.configuracaoAcesso.recuperarSenha
    },
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    buttonStyle () {
      return {
        'background-color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    styleSecundario () {
      return {
        'background-color': this.estilo.aplicacao.corSecundariaAplicacao
      }
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    async init () {
      this.initFormIdentificacao()
    },
    initFormIdentificacao () {
      this.initForm(
        this.funcData.parametros.formularios.formIdentificacao,
        'form-render-identificacao'
      )
    },
    initForm (formId, id) {
      let params = {
        identifier: id,
        clientKey: this.config.aplicacao.clientKey,
        'idForm': formId,
        'colors': { ...this.formBuilderColors }
      }
      this.form = renderForm(params)
    },
    showError () {
      this.erro.descricao = ``
      this.erro.show = true
    },
    async enviar () {
      this.erro.show = false

      const formData = await this.form.validateAll()
      if (!formData || !formData.status) {
        return
      }

      const payload = formData.data

      const response = await this.apiAcesso.recuperarSenha.recuperarSenhaIdentificacao({
        payload,
        loading: true,
        notifyFailure: false,
        notifySuccess: true,
        handlerErrorIgnore: true
      })

      if (response.status) {
        this.$emit('submit', response.data)
      } else {
        if (response.code === 400) {
          this.mostrarErro.show = true
          this.mostrarErro.descricao = response.message
        } else {
          this.erro.descricao = `<ul><li>${response.message}</li></ul>`
          this.erro.show = true
        }
      }
    }
  }
}
</script>

<style scoped>
.recuperar-cabecalho {
  letter-spacing: 0;
  color: #333333;
  margin-top: 0;
}

.recuperar-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px !important;
}
</style>
